import React, { useState } from "react";
import DatePicker from "react-datepicker"; // For date fields
import "react-datepicker/dist/react-datepicker.css"; // Import DatePicker styles
import { useSearchParams, useNavigate } from "react-router-dom";
import $ from "jquery";
import api from "../../api/axiosInstance";
const FormPreview = ({ formData }) => {debugger;
  const [formValues, setFormValues] = useState({});

  const [queryParams] = useSearchParams();
  const flag = queryParams.get("flag");
  // Handle input changes
  const handleInputChange = (e, rowIndex, columnIndex, columnName) => {
    const { value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [`${rowIndex}-${columnIndex}-${columnName}`]: value,
    }));
  };


  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    border: "1px solid #ccc",
  };
  
  const tableHeaderStyle = {
    backgroundColor: "#007bff", // Blue header
    color: "white",
    fontWeight: "bold",
    padding: "10px",
    textAlign: "left",
    borderBottom: "2px solid #0056b3",
  };
  
  const tableRowStyleEven = {
    backgroundColor: "#f9f9f9", // Light gray row
  };
  
  const tableRowStyleOdd = {
    backgroundColor: "#ffffff", // White row
  };
  
  const tableCellStyle = {
    padding: "10px",
    borderBottom: "1px solid #ddd",
  };
  
  const tableInputStyle = {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "#f7f9fc",
  };
  const formContainerStyle = {
    width: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
  };

  const sectionHeaderStyle = {
    backgroundColor: "#f7f7f7",
    padding: "10px",
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "bold",
marginLeft: "89%",
    marginBottom: "15px",
  };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const recordGuidStr = searchParams.get("recordGuidStr"); // Extract ID from URL query params

  const handleBackClick = () => {
    debugger;
    if(flag==='formMaster')
    {
  navigate(`/editor/FormMastersView/${recordGuidStr}`);
    }
    else 
    {
        navigate(`/editor/FormMastersForApprover`);
    }
  
  };


  // Render form elements based on TypeValue
 // Render form elements based on TypeValue
 const renderColumn = (column, rowIndex, columnIndex) => {debugger;
  const labelStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "4px",
    display: "block",
    minWidth: "120px", // Ensures labels are aligned
  };

  const inputStyle = {
    width: "100%",
    padding: "5px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const optionContainerStyle = {
    // display: "grid",
    // gridTemplateColumns: `auto auto auto`,
    // gap: "10px",
    alignItems: "center",

  };

  
  

  switch (column.typeValue) {
    case 121440002:
      return(
      <h3 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>
      {column.header}
    </h3>);
    case 121440003:
      return (
        <h4 style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold",marginLeft:'10px' }}>
          {column.subHeader}
        </h4>
      );
      case 121440004:
        return (
          <div>
            {column.onlyTextParas && column.onlyTextParas.length > 0 ? (
              column.onlyTextParas.map((str, index) =>
                str.trim() !== "" ? (
                  <p key={index} style={{ textAlign: "left", marginBottom: 0 }}>{str}</p>
                ) : (
                  <br key={index} />
                )
              )
            ) : null}
          </div>
        );
        case 121440005:
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                {column.singleLineTextboxLabel}
                {column.isMandatory && <span style={{ color: "red" }}> *</span>}
              </label>
              <input
                type="text"
                style={inputStyle}
                value={formValues[`${rowIndex}-${columnIndex}-text`] || ""}
                onChange={(e) => handleInputChange(e, rowIndex, columnIndex, "text")}
                maxLength={1000}
              />
            </div>
          );
      case 121440006:
        return (
          <div>
            {column.isMandatory && <label>{column.multilineTextboxLabel}<span style={{ color: 'red' }}> *</span></label>}
            {!column.isMandatory && <label>{column.multilineTextboxLabel}</label>}
            <textarea
              style={{ width: '100%',
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #d1d5db", // Tailwind's gray-300
                backgroundColor:  "#ffffff",
                resize: "vertical",
                fontSize: "14px",
                color: "#111827", // gray-900
                outline: "none",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
               }}
              rows={column.mltxtRows}
              maxLength={5000}
              value={formValues[`${rowIndex}-${columnIndex}-textarea`] || ''}
              onChange={(e) => handleInputChange(e, rowIndex, columnIndex, 'textarea')}
            />
          </div>
        );
      case 121440007:
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.dateTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              type="date"
              style={inputStyle}
              value={formValues[`${rowIndex}-${columnIndex}-date`] || ""}
              onChange={(e) => handleInputChange(e, rowIndex, columnIndex, "date")}
            />
          </div>
        );
    
    case 121440008:
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={labelStyle}>
            {column.numberTextboxLabel}
            {column.isMandatory && <span style={{ color: "red" }}> *</span>}
          </label>
          <input
            type="number"
            style={inputStyle}
            value={formValues[`${rowIndex}-${columnIndex}-number`] || ""}
            onChange={(e) => handleInputChange(e, rowIndex, columnIndex, "number")}
            maxLength={100}
          />
        </div>
      );

    case 121440009:
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
            {column.radioButtonsLabel}&nbsp;: &nbsp;
            {column.isMandatory && <span style={{ color: "red" }}> *</span>}
          </label>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {column.options.map((option, index) => (
              <label
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "8px",
                  border: formValues[`${rowIndex}-${columnIndex}-radio`] === option.value
                    ? "2px solid #007bff"
                    : "2px solid #ccc",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: formValues[`${rowIndex}-${columnIndex}-radio`] === option.value
                    ? "#e7f1ff"
                    : "#fff",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name={`radio-${rowIndex}-${columnIndex}`}
                  value={option.value}
                  checked={formValues[`${rowIndex}-${columnIndex}-radio`] === option.value}
                  onChange={(e) => handleInputChange(e, rowIndex, columnIndex, "radio")}
                  style={{ display: "none" }} // Hide default radio button
                />
                <span
                  style={{
                    display: "inline-block",
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    border: "2px solid #007bff",
                    position: "relative",
                  }}
                >
                  {formValues[`${rowIndex}-${columnIndex}-radio`] === option.value && (
                    <span
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#007bff",
                        borderRadius: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    ></span>
                  )}
                </span>
                <b style={{ fontSize: "14px", color: "#333" }}>{option.text}</b>
              </label>
            ))}
          </div>
        </div>
      );
    case 121440010:
  return (
    <div style={{ marginBottom: "20px" }}>
      {/* Label */}
      <label
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          marginBottom: "8px",
          display: "block",
        }}
      >
        {column.checkboxesLabel}
        {column.isMandatory && <span style={{ color: "red" }}> *</span>}
      </label>

      {/* Checkbox Options */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
        {column.options.map((option, index) => {
          const isChecked =
            formValues[`${rowIndex}-${columnIndex}-checkbox-${option.value}`] === true;

          return (
            <div key={index}>
              <label
                htmlFor={`${rowIndex}-${columnIndex}-checkbox-${option.value}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#f1f3f5",
                  padding: "6px 12px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  id={`${rowIndex}-${columnIndex}-checkbox-${option.value}`}
                  checked={isChecked}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      rowIndex,
                      columnIndex,
                      `checkbox-${option.value}`
                    )
                  }
                  style={{ accentColor: "#28a745" }}
                />
                {option.text}
              </label>

              <span
                className="field-validation-valid"
                style={{ color: "red" }}
              ></span>
            </div>
          );
        })}
      </div>
    </div>
  );

    case 121440011:
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
            {column.listboxLabel}&nbsp;: &nbsp;{column.isMandatory && <span style={{ color: "red" }}> *</span>}
          </label>
          <select
            value={formValues[`${rowIndex}-${columnIndex}-select`] || ""}
            onChange={(e) => handleInputChange(e, rowIndex, columnIndex, "select")}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
              backgroundColor: "#f7f9fc",
              cursor: "pointer",
              outline: "none",
              appearance: "none", // Removes default dropdown styles
              backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"black\"><path fill-rule=\"evenodd\" d=\"M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></svg>')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              backgroundSize: "12px",
            }}
          >
            <option value="">-- Select --</option>
            {column.options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
        </div>
      );
      case 121440012:
        return (
          <div>
            <label style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px", display: "block",textAlign :'center' }}>
              {column.tableLabel}
            </label>
            <table style={tableStyle}>
              <thead>
                <tr>
                  {column.options.map((option, index) => (
                    <th key={index} style={tableHeaderStyle}>
                      {option.text}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[...Array(column.tableRows)].map((_, rowIdx) => (
                  <tr key={rowIdx} style={rowIdx % 2 === 0 ? tableRowStyleEven : tableRowStyleOdd}>
                    {column.options.map((_, colIdx) => (
                      <td key={colIdx} style={tableCellStyle}>
                        <input
                          type="text"
                          maxLength={100}
                          style={tableInputStyle}
                          value={formValues[`${rowIndex}-${columnIndex}-table-${rowIdx}-${colIdx}`] || ""}
                          onChange={(e) => handleInputChange(e, rowIndex, columnIndex, `table-${rowIdx}-${colIdx}`)}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );

    default:
      return null;
  }
};

return (
  
  <div style={formContainerStyle}>
<div style={{ padding: "20px"}}>
      <button
        onClick={handleBackClick}
        style={{
          padding: "6px 10px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          fontSize: "16px",
          cursor: "pointer",
          transition: "background 0.3s ease",
        }}
      >
        Back
      </button>
    </div>
    {formData.listSections.map((section, sectionIndex) => (
      <div key={section.id} style={{ marginBottom: "20px" }}>
        <div style={sectionHeaderStyle}>Form Preview</div>

        {section.listRows.map((row, rowIndex) => {
          const isFullWidth = row.isFull;

          return (
            <div
              key={rowIndex}
              style={{
                display: "grid",
                gridTemplateColumns: isFullWidth
                  ? "1fr"
                  : `repeat(${section.noOfColumns}, 1fr)`,
                gap: "10px",
                marginBottom: "15px",
              }}
            >
              {row.column1 && renderColumn(row.column1, rowIndex, 1)}
              {!isFullWidth && row.column2 && renderColumn(row.column2, rowIndex, 2)}
              {!isFullWidth && row.column3 && renderColumn(row.column3, rowIndex, 3)}
              {!isFullWidth && row.column4 && renderColumn(row.column4, rowIndex, 4)}
            </div>
          );
        })}
      </div>
    ))}
  </div>
);
};

export default FormPreview;
